import { Config } from '@oscar/request';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Provider, IProvider } from '../types';
import { Msa } from './providers';

export default (config?: Provider['SSO']) => {
  const providerRef = useRef<IProvider>();
  const [isLoaded, setIsLoaded] = useState(false);

  const wrapSSO = useMemo(() => {
    if (!providerRef.current && config) {
      if (config?.type === 'MSA') {
        const msa = new Msa(config);
        msa?.loadScript(() => {
          providerRef.current = msa;
          setIsLoaded(true);
        });
      }
    }
    return providerRef.current;
  }, [config, isLoaded]);

  useEffect(() => {
    if (!config || !isLoaded) {
      return;
    }
    const { redirectUri } = config;
    if (
      !Config.getInstance().getTokenValue() &&
      !location.href.toString().includes(redirectUri)
    ) {
      providerRef.current?.login();
    }
  }, [isLoaded]);

  return [wrapSSO];
};
